module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.title) ? [(_vm.checkLinkValue) ? _c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.title)),
      expression: "t(title)",
      arg: "tooltip"
    }],
    attrs: {
      "href": _vm.row[_vm.linkIndex],
      "target": "_blank",
      "rel": "noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.row[_vm.column.data]))]) : _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.title)),
      expression: "t(title)",
      arg: "tooltip"
    }]
  }, [_vm._v(_vm._s(_vm.row[_vm.column.data]))])] : [(_vm.checkLinkValue) ? _c('a', {
    attrs: {
      "href": _vm.row[_vm.linkIndex],
      "target": "_blank",
      "rel": "noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.row[_vm.column.data]))]) : _c('span', [_vm._v(_vm._s(_vm.row[_vm.column.data]))])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5023e6ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/ProductLinkComponent.vue
// module id = 1285
// module chunks = 2